import { getRingbaPhoneNumberTemplate, getInnerRingbaPhoneNumberTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "../../shortodeAddition";

const editRingbaPhoneNumberConfig = (editor, phoneNumberDiv) => {
  let currentData = null;

  const ringbaPhoneNumberWindow = editor.windowManager.openUrl({
    title: "Edit Ringba Phone Number",
    url: "/ringba-phone-number-dialog",

    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!currentData?.ringbaPhoneNumber || !currentData?.buttonType) {
        ringbaPhoneNumberWindow.sendMessage({
          type: "errorData",
          data: "Please select a phone number",
        });

        return;
      }

      const templateToAdd = getInnerRingbaPhoneNumberTemplate(currentData);
      phoneNumberDiv.innerHTML = templateToAdd;
      phoneNumberDiv.setAttribute("data-ringba-phone-number", JSON.stringify(currentData));

      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }
      if (message.mceAction === "updateRingbaPhoneNumberData") {
        currentData = message.data;
      }
    },
    width: 400,
    height: 350,
  });
  const sendData = () => {
    let existData = phoneNumberDiv.getAttribute("data-ringba-phone-number");
    ringbaPhoneNumberWindow.sendMessage({
      type: "sendData",
      data: existData,
    });
  };
};

const ringbaPhoneNumberConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  const ringbaPhoneNumberWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Add Ringba Phone Number",
    url: "/ringba-phone-number-dialog",
    width: 400,
    height: 350,
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!currentData?.ringbaPhoneNumber || !currentData?.buttonType) {
        ringbaPhoneNumberWindow.sendMessage({
          type: "errorData",
          data: "Please select a phone number",
        });

        return;
      }

      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getRingbaPhoneNumberTemplate(currentData);
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd, "ringba-phone-number");

      const tempWrapper = document.createElement("div");
      tempWrapper.innerHTML = shortcodeWrapper.trim();
      tempWrapper
        .querySelector("div[data-ringba-phone-number]")
        ?.setAttribute("data-ringba-phone-number", JSON.stringify(currentData));

      addShortcodeToEditor(tempWrapper.innerHTML, uuid, parentElement);
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "updateRingbaPhoneNumberData") {
        currentData = message.data;
      }
    },
  });
};

export { editRingbaPhoneNumberConfig, ringbaPhoneNumberConfig };
